import React, { Component } from 'react';
import { FormGroup, Label, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import validator from 'validator';
import SingleOtherPicker from '../common/controls/singleOtherPicker';
import entityComposition from '../common/classes/entityComposition';
import NumberInput from '../common/controls/numberInput';
import MultiPicker from '../common/controls/multiPicker';
class AssetCoatings extends Component {
  componentDidMount() {
    const _this$props = this.props,
      assetCoatingSystem = _this$props.assetCoatingSystem,
      assetCoatingSystemActions = _this$props.assetCoatingSystemActions,
      assetCoatingSecondaryCondition = _this$props.assetCoatingSecondaryCondition,
      assetCoatingSecondaryConditionActions = _this$props.assetCoatingSecondaryConditionActions;
    assetCoatingSystemActions.serverIndex(assetCoatingSystem.indexQuery);
    assetCoatingSecondaryConditionActions.serverIndex(assetCoatingSecondaryCondition.indexQuery);
  }
  render() {
    const _this$props2 = this.props,
      asset = _this$props2.asset,
      assetActions = _this$props2.assetActions,
      assetCoatingSystem = _this$props2.assetCoatingSystem,
      assetCoatingSecondaryCondition = _this$props2.assetCoatingSecondaryCondition;
    const assetID = asset.id,
      assetCoatingSystemOther = asset.assetCoatingSystemOther,
      assetCoatingSystemID = asset.assetCoatingSystemID,
      coatingSecondaryConditions = asset.coatingSecondaryConditions,
      coatingDFTToleranceLow = asset.coatingDFTToleranceLow,
      coatingDFTToleranceHigh = asset.coatingDFTToleranceHigh,
      coatingDFTFactorWithinLimits = asset.coatingDFTFactorWithinLimits,
      coatingDFTFactorOutsideLimits = asset.coatingDFTFactorOutsideLimits,
      details = asset.details;
    const handleChange = (name, value) => assetActions.change(assetID, name, value);
    const handleCoatingDFTToleranceLow = value => handleChange('coatingDFTToleranceLow', value);
    const handleCoatingDFTToleranceHigh = value => handleChange('coatingDFTToleranceHigh', value);
    const handleCoatingDFTFactorWithinLimits = value => handleChange('coatingDFTFactorWithinLimits', value);
    const handleCoatingDFTFactorOutsideLimits = value => handleChange('coatingDFTFactorOutsideLimits', value);
    const handleCoatingSystemUpdate = value => {
      let validValue = ''; // validator requires a string and throws error on null
      if (value !== null) {
        validValue = value;
      }
      let newAssetCoatingSystemID = null;
      let newAssetCoatingSystemOther = null;
      if (validator.isUUID(validValue)) {
        newAssetCoatingSystemID = validValue;
      } else {
        newAssetCoatingSystemOther = validValue;
      }
      handleChange('assetCoatingSystemID', newAssetCoatingSystemID);
      handleChange('assetCoatingSystemOther', newAssetCoatingSystemOther);

      // If any of the factors are empty, set them to defaults
      if (!coatingDFTToleranceLow) {
        handleCoatingDFTToleranceLow(10);
      }
      if (!coatingDFTToleranceHigh) {
        handleCoatingDFTToleranceHigh(20);
      }
      if (!coatingDFTFactorWithinLimits) {
        handleCoatingDFTFactorWithinLimits(2);
      }
      if (!coatingDFTFactorOutsideLimits) {
        handleCoatingDFTFactorOutsideLimits(1.5);
      }
    };
    let total = 0;
    if (details) {
      for (let i = 0, len = details.length; i < len; i += 1) {
        const surfaceArea = details[i].surfaceArea;
        if (surfaceArea) {
          total += parseFloat(surfaceArea);
        }
      }
    }
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Coating Details"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area Total"), /*#__PURE__*/React.createElement(NumberInput, {
      id: "assetCoatingsNumber",
      value: +total.toFixed(2),
      disabled: true
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(SingleOtherPicker, {
      label: "Coating System",
      labelKey: "name",
      onChange: handleCoatingSystemUpdate,
      options: assetCoatingSystem.list,
      placeholder: "Select or add a coating system",
      returnValueKey: "id",
      value: assetCoatingSystemID || assetCoatingSystemOther
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(MultiPicker, {
      label: "Secondary Condition",
      labelKey: "name",
      onChange: value => handleChange('coatingSecondaryConditions', value),
      options: assetCoatingSecondaryCondition.list,
      placeholder: "Select...",
      values: coatingSecondaryConditions
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement("h5", {
      className: "text-input-custom-label"
    }, "Dry Film Thickness Tolerance"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(NumberInput, {
      name: "coatingDFTToleranceLow",
      placeholder: "Low",
      value: coatingDFTToleranceLow,
      entity: "Asset",
      field: "coatingDFTToleranceLow",
      onChange: handleCoatingDFTToleranceLow
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(NumberInput, {
      placeholder: "High",
      value: coatingDFTToleranceHigh,
      entity: "Asset",
      field: "coatingDFTToleranceHigh",
      onChange: handleCoatingDFTToleranceHigh
    })))), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement("h5", {
      className: "text-input-custom-label"
    }, "Dry Film Thickness Factor"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(NumberInput, {
      placeholder: "Within Limits",
      value: coatingDFTFactorWithinLimits,
      entity: "Asset",
      field: "coatingDFTFactorWithinLimits",
      onChange: handleCoatingDFTFactorWithinLimits
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(NumberInput, {
      placeholder: "Outside Limits",
      value: coatingDFTFactorOutsideLimits,
      entity: "Asset",
      field: "coatingDFTFactorOutsideLimits",
      onChange: handleCoatingDFTFactorOutsideLimits
    }))))));
  }
}
AssetCoatings.propTypes = {
  asset: PropTypes.shape({
    coatingDFTFactorOutsideLimits: PropTypes.number,
    coatingDFTFactorWithinLimits: PropTypes.number,
    coatingDFTToleranceHigh: PropTypes.number,
    coatingDFTToleranceLow: PropTypes.number,
    id: PropTypes.string,
    assetCoatingSystemOther: PropTypes.string,
    assetCoatingSystemID: PropTypes.string,
    coatingSecondaryConditions: PropTypes.arrayOf(PropTypes.shape({})),
    details: PropTypes.arrayOf(PropTypes.shape({
      surfaceArea: PropTypes.number
    }))
  }).isRequired,
  assetActions: PropTypes.shape({
    change: PropTypes.func
  }).isRequired,
  assetCoatingSystem: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({})
  }).isRequired,
  assetCoatingSystemActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetCoatingSecondaryCondition: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({})
  }).isRequired,
  assetCoatingSecondaryConditionActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
export { AssetCoatings as TestAssetCoatings };
export default entityComposition(AssetCoatings, ['assetCoatingSystem', 'assetCoatingSecondaryCondition']);